const tabKeys = {
  SAMPLE: {
    CALL_API: "CALL_API",
    PASS_DATA: "PASS_DATA",
    HANDLE_FORM: "HANDLE_FORM",
    REF: "REF",
    SET_HEADER: "SET_HEADER",
    TABLE_FORMLIST: "TABLE_FORMLIST",
    MODAL: "MODAL",
  },
  TRAINING: {
    TAB_CV: "TAB_CV_TRAINING",
    LIST_TRAINNING: "LIST_TRAINING",
    HISTORY_TRAINING: "HISTORY_TRAINING",
  },
  CANDIDATES: {
    TAB_1: "TAB_1_CANDIDATES",
    TAB_2: "TAB_2_CANDIDATES",
    TAB_3: "TAB_3_CANDIDATES",
  },
  MODAL_TRAINING: {
    TAB_1: "TAB_1_TRAINING",
    TAB_2: "TAB_2_TRAINING",
  },
  RECEIVE: {
    TAB_1: "TAB_1",
    TAB_2: "TAB_2",
    TAB_3: "TAB_3",
    TAB_4: "TAB_4",
    TAB_5: "TAB_5",
    TAB_6: "TAB_6",
    REPORT: "REPORT_OPD",
    CONFIG_CATALOG: "CONFIG_CATALOG",
  },
  SEARCH_PATIENT: {
    LIST_PATIENT: "SEARCH_PATIENT_LIST",
    DETAIL: "SEARCH_PATIENT_DETAIL",
    HISTORY: "SEARCH_PATIENT_HISTORY",
  },
  EXAMINATION: {
    LIST_EXAM: "LIST_EXAM",
    INFOR_DETAIL: "INFOR_DETAIL",
    EXAM_HISTORY: "EXAM_HISTORY_EXAM",
    REPORT: "REPORT_EXAM",
    REPORT_REVENUE: "REPORT_REVENUE",
    CHART: "CHART",
    CHART_WATTING: "CHART_WATTING",
    CHART_EXAMATION: "CHART_EXAMATION",
    CHART_QUANTITY_PATIENT: "CHART_QUANTITY_PATIENT",
  },
  EXAMINATION_INFO_DETAIL: {
    EXAM: "EXAM",
    ASSIGN: "ASSIGN",
    ASSIGN_BILL: "ASSIGN_BILL",
    CONCLUDE_PRESCRIPT: "CONCLUDE_PRESCRIPT",
  },
  NURSE_OUT: {
    LIST_PATIENT: "LIST_PATIENT",
    EXAM_HISTORY: "EXAM_HISTORY_NURSE_OUT",
    DETAIL_PATIENT: "DETAIL_PATIENT",
    CHART: "CHART_NURSE_OUT",
    CATALOG: "CATALOG_NURSE_OUT",
  },
  REFRACTION: {
    REFRACTION_LIST: "REFRACTION_LIST",
    REFRACTION_TABLE: "REFRACTION_TABLE",
    REFRACTION_INFO: "REFRACTION_INFO",
    HISTORY_REFRACTION: "HISTORY_REFRACTION",
    REPORT_ORTHOR_K: "REPORT_ORTHOR_K",
  },
  SURGERY: {
    PATIENT_LIST: "PATIENT_LIST",
    DETAIL_INFO: "DETAIL_INFO",
    EXAM_HISTORY: "EXAM_HISTORY_SURGERY",
    ADVANCE_REPORT: "ADVANCE_REPORT",
    SETUP_SURGERY: "SETUP_SURGERY",
  },
  PAY: {
    LIST_PENDING: "LIST_PENDING",
    PAY_TAB: "PAY_TAB",
    PAY_OTHER: "PAY_OTHER",
    COLLECTION_OTHER: "COLLECTION_OTHER",
    REPORT: "REPORT_PAY",
    HISTORY: "HISTORY",
  },
  PAYCHILD: {
    PAY_CHILD: "PAY_CHILD",
    PAYMENT: "PAYMENT",
    CANCEL_PAY: "CANCEL_PAY",
    REFUNDS: "REFUNDS",
    EXEMPTIONS: "EXEMPTIONS",
    HISTORY_PAY: "HISTORY_PAY",
    TICKET_PAY: "TICKET_PAY",
    PAY_RESIDENT: "PAY_RESIDENT",
    VOUCHER: "VOUCHER",
  },
  GLASSES_STOREHOUSE: {
    STORE_GLASS: "STORE_GLASS",
    IMPORT: "IMPORT_GLASSES_STOREHOUSE",
    EXPORT: "EXPORT_GLASSES_STOREHOUSE",
    DETAIL: "DETAIL_GLASS_STORE",
    REPORT_TAB_GLASS: "REPORT_GLASSES_STOREHOUSE",
    CATALOG: "CATALOG_GLASSES_STOREHOUSE",
  },
  GLASSES: {
    TAB_1: "TAB_1_GLASSES",
    TAB_2: "TAB_2_GLASSES",
    LIST_1: "LIST_1_GLASSES",
    LIST_2: "LIST_2_GLASSES",
    LIST_3: "LIST_3_GLASSES",
    HISTORY_TAB: "HISTORY_TAB_GLASSES",
  },
  AUTHORIZATION: {
    ROLE: "ROLE",
    API: "API",
    FUNCTION: "FUNCTION",
    ROLE_CHUCNANG: "ROLE_CHUCNANG",
    API_ROLE: "API_ROLE",
    ACCOUNT: "ACCOUNT",
    BRANCH: "BRANCH",
  },
  DIAGNOSE: {
    LIST_PATIENT: "LIST_PATIENT_DIAGNOSE",
    DETAIL_INFO: "DETAIL_INFO_DIAGNOSE",
    EXAM_HISTORY: "EXAM_HISTORY_DIAGNOSE",
    CHART: "CHART_DIAGNOSE",
    CATALOG: "CATALOG_DIAGNOSE",
    DIAGNOSE_TABLE: "DIAGNOSE_TABLE",
  },
  ELECTROCARDIOGRAPHY: {
    LIST_PATIENT: "LIST_PATIENT_ELECTRO",
    DETAIL_INFO_ELECTRO: "DETAIL_INFO_ELECTRO",
    EXAM_HISTORY: "EXAM_HISTORY_ELECTRO",
    CHART: "CHART_ELECTRO",
    CATALOG: "CATALOG_ELECTRO",
    ELECTROCARDIOGRAPHY_TABLE: "ELECTROCARDIOGRAPHY_TABLE",
  },
  CUSTOMER_CARE: {
    CARE: "CARE",
    ALl: "ALL",
    APPOITMENT: "APPOITMENT",
    REJECT: "REJECT",
    BACK_TO_THE_DOCTOR: "BACK_TO_THE_DOCTOR",
    CARE_DETAIL: "CARE_DETAIL",
    EXAMINATION_HISTORY: "EXAMINATION_HISTORY_CUSTOMER",
    ADVANCE_REPORT: "ADVANCE_REPORT",
    CSKH_MANAGEMENT: "CSKH_MANAGEMENT",
    REMAIN_PATIENT: "REMAIN_PATIENT",
    HISTORY_CSKH: "HISTORY_CSKH",
    BD_PATIENT: "BD_PATIENT",
  },
  SERVICE_AND_OFFER: {
    OFFER_LIST: "OFFER_LIST",
    SERVICE_LIST: "SERVICE_LIST",
    ADVANCE_REPORT: "ADVANCE_REPORT",
  },
  CARD_AND_OFFER: {
    CARD_TYPES: "CARD_TYPES",
    DISCOUNTS: "DISCOUNTS",
    DISCOUNTSADD: "DISCOUNTSADD",
  },
  MEDICINE_STORE: {
    LIST_PRESCRIPTION: "LIST_PRESCRIPTION",
    LIST_1: "LIST_1",
    LIST_2: "LIST_2",
    LIST_3: "LIST_3",
    PRESCRIPTION_DETAIL: "EXPORT_DETAIL",
    CATALOG: "CATALOG_MEDICINE",
    ALLOCATION: "ALLOCATION_MEDICINE",
    ALLOCATION_LIST: "ALLOCATION_LIST",
    ALLOCATION_DETAIL: "ALLOCATION_DETAIL",
  },
  PHARMACY_STORE: {
    LIST_PHARMACY: "LIST_PHARMACY",
    IMPORT: "IMPORT_PHARMACY",
    EXPORT: "EXPORT_PHARMACY",
    RESERVE: "RESERVE",
    DETAIL: "DETAIL_PHARMACY",
    ALLOCATION: "ALLOCATION",
    ALLOCATION_LIST: "ALLOCATION_LIST",
    ALLOCATION_DETAIL: "ALLOCATION_DETAIL",
    INVENTORY: "INVENTORY",
    INVENTORY_DETAIL: "INVENTORY_DETAIL",
    CHART: "CHART_PHARMACY",
    REPORT: "REPORT_PHARMACY",
    CATALOG: "CATALOG_PHARMACY",
    BID_DEADLINE: "BID_DEADLINE_PHARMACY",
  },
  MEDICAL_SUPPLIES_STORE: {
    LIST_PHARMACY: "LIST_MEDICAL_SUPPLIER",
    IMPORT: "IMPORT_MEDICAL_SUPPLIER",
    EXPORT: "EXPORT_MEDICAL_SUPPLIER",
    RESERVE: "RESERVE_MEDICAL_SUPPLIER",
    DETAIL: "DETAIL_MEDICAL_SUPPLIER",
    ALLOCATION: "ALLOCATION_MEDICAL_SUPPLIER",
    INVENTORY: "INVENTORY_MEDICAL_SUPPLIER",
    INVENTORY_DETAIL: "INVENTORY_DETAIL_MEDICAL_SUPPLIER",
    REPORT: "REPORT_MEDICAL_SUPPLIER",
    CATALOG: "CATALOG_MEDICAL_SUPPLIER",
    BID_DEADLINE: "BID_DEADLINE_MEDICAL_SUPPLIES",
  },
  EMPLOYEE: {
    LIST_EMPLOYEE: "LIST_EMPLOYEE",
    LICENSE: "LICENSE",
    license: "EXPORT_EMPLOYEE",
    CONTRACT: "CONTRACT",
    DETAIL: "DETAIL_EMPLOYEE",
    CATALOG: "CATALOG_EMPLOYEE",
    WORK_HISTORY: "WORK_HISTORY",
  },
  SHIFT: {
    DIVISION_WORK: "DIVISION_WORK",
    CONFIGURE_WORK_SHIFT: "CONFIGURE_WORK_SHIFT",
  },
  TEXT: {
    TEXTAWAY: "TEXT_AWAY",
    TEXTARRIVE: "TEXT_ARRIVE",
  },
  XML: {
    PUSH_XML: "EXPORT_XML",
    RENDER_XML: "RENDER_XML",
  },

  ANALYSIS: {
    LIST_PATIENT_ANALYSIS: "LIST_PATIENT_ANALYSIS",
    DETAIL_PATIENT_ANALYSIS: "DETAIL_PATIENT_ANALYSIS",
    HISTORY_ANALYSIS: "HISTORY_ANALYSIS",
    REPORT_WAITTING_ANALYSIS: "REPORT_WAITTING_ANALYSIS",
    CATEGORY_ANALYSIS: "CATEGORY_ANALYSIS",
    BOOK_ANALYSIS: "BOOK_ANALYSIS",
  },

  NURSING: {
    LIST_PATIENT: "LIST_PATIENT_NURSING",
    DETAILS: "DETAILS",
    HISTORY_EXAMINE: "HISTORY_EXAMINE_NURSING",
  },
  CONSULTANT_AND_FRAGMENT: {
    LIST_CONSULTANT_AND_FRAGMENT: "LIST_CONSULTANT_AND_FRAGMENT",
    LIST_CONSULTANT_AND_FRAGMENT_RECEIVED:
      "LIST_CONSULTANT_AND_FRAGMENT_RECEIVED",
    CONSULTANT_AND_FRAGMENT_TABLE: "CONSULTANT_AND_FRAGMENT_TABLE",
    DETAIL_CONSULTANT_AND_FRAGMENT: "DETAIL_CONSULTANT_AND_FRAGMENT",
    HISTORY_EXAMINE: "HISTORY_EXAMINE_CONSULTANT_AND_FRAGMENT",
    EXAMINATION_CARD: "EXAMINATION_CARD",
    REPORT: "REPORT_CONSULT",
    APPOITMENT: "APPOITMENT",
  },
  TECHNICAL_SERVICE: {
    TECHNICAL_SERVICE: "TECHNICAL_SERVICE",
    CATALOG: "CATALOG",
  },

  CATALOG_EMPLOYEE: {
    TAB_POSITION: "TAB_POSITION",
    TAB_DEPARTMENT: "TAB_DEPARTMENT",
    TAB_WORKING: "TAB_WORKING",
    TAB_WORK: "TAB_WORK",
    TAB_CONTRACT: "TAB_CONTRACT",
    TAB_MONTH_SABBATICAL: "TAB_MONTH_SABBATICAL",
    TAB_WORK_ADDRESS: "TAB_WORK_ADDRESS",
  },

  REVENUES_REPORT: {
    REVENUES_IN_ITEM: "REVENUES_IN_ITEM",
    REVENUES_IN_CUSTOMER: "REVENUES_IN_CUSTOMER",
    REVENUES_IN_SURGERY: "REVENUES_IN_SURGERY",
  },

  STORE_REPORT: {
    ALL_REPORT: "ALL_REPORT",
    DETAIL_REPORT: "DETAIL_REPORT",
  },
  COMBINE_REPORT: {
    PHAU_THUAT_REPORT: "PHAU_THUAT_REPORT",
    THU_THUAT_REPORT: "THU_THUAT_REPORT",
    KHAM_MAT_REPORT: "KHAM_MAT_REPORT",
    TU_VAN_REPORT: "TU_VAN_REPORT",
    GIOI_TINH_REPORT: "GIOI_TINH_REPORT",
    CHAT_LUONG_REPORT: "CHAT_LUONG_REPORT",
    KINH_REPORT: "KINH_REPORT",
    MARKKETING_REPORT: "MARKKETING_REPORT",
    THEKHAM_REPORT: "THEKHAM_REPORT",
  },
  PROPOSE_SHOPPING: {
    LIST: "LIST_PROPOSE_SHOPPING",
    DETAIL: "DETAIL_PROPOSE_SHOPPING",
    CATALOG: "CATALOG_PROPOSE_SHOPPING",
  },
  PROPOSE_PAY: {
    LIST: "LIST_PROPOSE_PAY",
    DETAIL: "DETAIL_PROPOSE_PAY",
  },
};
export {tabKeys};
